module.exports = __webpack_public_path__ + "img/sketch-airplane.6d0adf52.png";